import { render, staticRenderFns } from "./collegemajor.vue?vue&type=template&id=048f5503&scoped=true&"
import script from "./collegemajor.vue?vue&type=script&lang=js&"
export * from "./collegemajor.vue?vue&type=script&lang=js&"
import style0 from "./collegemajor.vue?vue&type=style&index=0&id=048f5503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f5503",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDataTable,VIcon,VTextField})
